import { render, staticRenderFns } from "./printRecord.vue?vue&type=template&id=86ef2e78&scoped=true"
import script from "./printRecord.vue?vue&type=script&lang=js"
export * from "./printRecord.vue?vue&type=script&lang=js"
import style0 from "./printRecord.vue?vue&type=style&index=0&id=86ef2e78&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86ef2e78",
  null
  
)

export default component.exports